module.exports = __webpack_public_path__ + "static/media/i1.e75bf1b9.svg";